const API_AUTH_USERNAME = "StaffManagement";
const API_AUTH_PASSWORD = "t746/mFxin8ks74or8hg";
const API_BASE_URL = "https://microdynamicsoftware.uk/StaffManagement/";
const WAIVER_REGESTRATION_LINK = "https://skyflypark.com/skyflypark/registration_form"
const MOBILE_NUMBER = "8793405400";
const EMAIL_ADDRESS = "skyflyparkbaner@gmail.com";
const COMPANY_ADDRESS =
  "SkyFlyPark Baner Pan Card Club Road,Kalpataru Jade Road,Baner, Pune 411057";
const MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d121039.29361435844!2d73.70268016653645!3d18.5524800265993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bc2bf7e9069caeb%3A0x2b60ff26cf67e7f!2sBaner%2C%20Pune%2C%20Maharashtra%20411045!3m2!1d18.5524979!2d73.7850819!5e0!3m2!1sen!2sin!4v1758105030883!5m2!1sen!2sin";
const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61582351888671";
const INSTGRAM_URL = "https://www.instagram.com/skyflypark/";
const LINKEDIN_URL = "https://www.linkedin.com/in/skyfly-park-884911387/";
const YOU_TUBE_URL = "https://www.youtube.com/@SkyflyPark/";
export {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
  MOBILE_NUMBER,
  EMAIL_ADDRESS,
  FACEBOOK_URL,
  INSTGRAM_URL,
  LINKEDIN_URL,
  YOU_TUBE_URL,
  MAP_URL,
  COMPANY_ADDRESS,
  WAIVER_REGESTRATION_LINK
};

